export const AUTHEN = 'AUTHEN';
export const REWARD_CATEGORY = 'REWARD_CATEGORY';
export const COMPANY_LIST = 'COMPANY_LIST';
export const COMPANY_SELECTED = 'COMPANY_SELECTED';
